/*
** import MDC (Material Design Components) color palette
*/
// import colors from 'vuetify/es5/util/colors'

/*
** define theme colors
*/
export default {
    theme: {
        primary: '#2b3b8b',
        secondary: '#00bcd4'
    }
}
